export enum TransactionsTypes {
    Repayment = 'Repayment',
    Disbursement = 'Disbursement',
}
